var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 0C3.5888 0 0 3.5888 0 8V11.3144C0 12.1336 0.7176 12.8 1.6 12.8H2.4C2.61217 12.8 2.81566 12.7157 2.96569 12.5657C3.11571 12.4157 3.2 12.2122 3.2 12V7.8856C3.2 7.67343 3.11571 7.46994 2.96569 7.31991C2.81566 7.16989 2.61217 7.0856 2.4 7.0856H1.6736C2.1184 3.9896 4.7824 1.6 8 1.6C11.2176 1.6 13.8816 3.9896 14.3264 7.0856H13.6C13.3878 7.0856 13.1843 7.16989 13.0343 7.31991C12.8843 7.46994 12.8 7.67343 12.8 7.8856V12.8C12.8 13.6824 12.0824 14.4 11.2 14.4H9.6V13.6H6.4V16H11.2C12.9648 16 14.4 14.5648 14.4 12.8C15.2824 12.8 16 12.1336 16 11.3144V8C16 3.5888 12.4112 0 8 0Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.9c44646d69b34903659a135db612bbba.svg";
export { ForwardRef as ReactComponent };